// eslint-disable-next-line import/no-cycle
import HTTP from '../http/common';

export default {
  list(data) {
    return HTTP.post('player', data);
  },

  payments(data) {
    return HTTP.post('player/payments', data);
  },

  details(id) {
    return HTTP.get(`player/details/${id}`);
  },
};
